import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import DueAmount from '../Layouts/DueAmountForm';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';
import { DueAmountFormValues } from 'src/models/Dashboard.model';
import DueAmountForm from '../Layouts/DueAmountForm';
import { useGetOfflineOrderByIdQuery, useGetSingleOfflineOrderDataQuery, useUpdateDueOrderByIdMutation } from 'src/services/OfflineOrderService';

type Props = {
  onClose: () => void;
  selectedDueAmountId: string
};

const EditDueAmountWrapper = ({ onClose, selectedDueAmountId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetSingleOfflineOrderDataQuery(selectedDueAmountId);
  const [updateDueAmountById] = useUpdateDueOrderByIdMutation();
  // useEffect(() => {
  //   if (!isLoading && !isFetching) {
  //     setItems(data?.data);
  //   }
  // }, [isLoading, isFetching, data]);
  const initialValues: DueAmountFormValues = {
   duedate:data?.data.duedate || "",
   remarks:""
  };
  // Validation Schema
  const validationSchema = Yup.object().shape({
    remarks: Yup.string().required('remark is required'),
    duedate: Yup.string().required('duedate is required'),

   

    
  });

  // Handle Submit
  const handleSubmit = (
    values: DueAmountFormValues,
    { setSubmitting, resetForm }: FormikHelpers<DueAmountFormValues>
  ) => {
    let payload: any = {
      duedate: values.duedate,
      remark: values.remarks,
    };

  
    updateDueAmountById({ id: selectedDueAmountId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {/* {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )} */}
            <DueAmountForm formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditDueAmountWrapper;